(function () {
  if (window.MaclinsShippingCalculatorLoaded) return;
  window.MaclinsShippingCalculatorLoaded = true;

  var SELECTOR = '[data-maclins-shipping-calculator]';

  function digits(value) { return String(value || '').replace(/\D/g, '').slice(0, 8); }
  function formatCep(value) { var clean = digits(value); return clean.length > 5 ? clean.slice(0, 5) + '-' + clean.slice(5) : clean; }
  function wait(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }

  function money(value) {
    var number = Number(String(value || '0').replace(',', '.'));
    if (!isFinite(number)) number = 0;
    if (number === 0) return '\u0047r\u00e1tis';
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number); }
    catch (e) { return 'R$ ' + number.toFixed(2).replace('.', ','); }
  }

  function deliveryText(rate) {
    var days = rate.delivery_days;
    if (Array.isArray(days) && days.length) {
      var min = Number(days[0]);
      var max = Number(days[days.length - 1]);
      if (isFinite(min) && isFinite(max)) {
        if (min === max) return min + (min === 1 ? ' dia útil' : ' dias úteis');
        return min + ' a ' + max + ' dias úteis';
      }
    }
    if (rate.delivery_range && Array.isArray(rate.delivery_range)) return rate.delivery_range.join(' a ');
    if (rate.delivery_date) return rate.delivery_date;
    return 'Prazo informado no checkout';
  }

  function setStatus(root, message, type) {
    var status = root.querySelector('.mc-frete-status');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    status.dataset.type = type || 'info';
  }

  function setLoading(root, loading) {
    root.classList.toggle('is-loading', loading);
    var button = root.querySelector('.mc-frete-submit');
    var input = root.querySelector('.mc-frete-cep');
    if (button) { button.disabled = loading; button.textContent = loading ? 'Calculando...' : 'Calcular'; }
    if (input) input.disabled = loading;
  }

  function renderRates(root, rates) {
    var list = root.querySelector('.mc-frete-rates');
    if (!list) return;
    list.innerHTML = '';
    list.hidden = !rates || !rates.length;
    if (!rates || !rates.length) return;
    rates.forEach(function (rate) {
      var li = document.createElement('li');
      var name = document.createElement('span');
      var price = document.createElement('strong');
      var eta = document.createElement('small');
      name.textContent = rate.name || rate.presentment_name || 'Frete';
      price.textContent = money(rate.price);
      eta.textContent = 'Prazo: ' + deliveryText(rate);
      li.appendChild(name); li.appendChild(price); li.appendChild(eta); list.appendChild(li);
    });
  }

  async function lookupAddress(zip) {
    try {
      var response = await fetch('https://viacep.com.br/ws/' + zip + '/json/', { credentials: 'omit', headers: { Accept: 'application/json' } });
      var data = await response.json();
      if (!response.ok || data.erro || !data.uf) throw new Error();
      return { province: data.uf, city: data.localidade || '' };
    } catch (e) {
      throw new Error('N\u00e3o conseguimos identificar o estado deste CEP. Confira o CEP e tente novamente.');
    }
  }

  async function postForm(url, params) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' }, body: params.toString(), credentials: 'same-origin' });
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, options || {}));
    var text = await response.text();
    var data = text ? JSON.parse(text) : {};
    if (!response.ok) {
      var message = data.message || data.description || 'N\u00e3o foi poss\u00edvel calcular o frete.';
      if (data.province) message = 'N\u00e3o conseguimos confirmar o estado deste CEP. Confira o CEP e tente novamente.';
      if (data.error) message = Array.isArray(data.error) ? data.error[0] : data.error;
      var error = new Error(message);
      error.status = response.status; error.data = data; throw error;
    }
    return data;
  }

  async function getCart() { return fetchJson('/cart.js'); }

  async function addVariant(variantId, quantity) {
    return fetchJson('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) || 1 }) });
  }

  async function restoreVariantQuantity(variantId, quantity) {
    var body = { updates: {} };
    body.updates[String(variantId)] = Number(quantity) || 0;
    return fetchJson('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }

  function shippingParams(zip, address) {
    var params = new URLSearchParams();
    params.append('shipping_address[zip]', formatCep(zip));
    params.append('shipping_address[country]', 'Brazil');
    params.append('shipping_address[country_code]', 'BR');
    params.append('shipping_address[province]', address.province);
    if (address.city) params.append('shipping_address[city]', address.city);
    return params;
  }

  async function requestRates(zip) {
    var address = await lookupAddress(zip);
    var params = shippingParams(zip, address);
    try {
      await postForm('/cart/prepare_shipping_rates.json', params);
      for (var i = 0; i < 8; i += 1) {
        await wait(i === 0 ? 450 : 700);
        var asyncData = await fetchJson('/cart/async_shipping_rates.json?' + params.toString());
        if (asyncData && Array.isArray(asyncData.shipping_rates)) return asyncData.shipping_rates;
      }
    } catch (e) {}
    var data = await fetchJson('/cart/shipping_rates.json?' + params.toString());
    return data.shipping_rates || [];
  }

  function productFormFor(root) { return root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'); }

  async function withProductInCart(root, callback) {
    if ((root.dataset.mode || 'cart') !== 'product') return callback();
    var form = productFormFor(root);
    if (!form) throw new Error('Selecione um produto para calcular o frete.');
    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = variantInput && variantInput.value;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!variantId) throw new Error('Selecione cor e tamanho antes de calcular.');
    if (!quantity || quantity < 1) quantity = 1;
    var cart = await getCart();
    var originalQuantity = cart.items.reduce(function (sum, item) { return String(item.variant_id) === String(variantId) ? sum + item.quantity : sum; }, 0);
    await addVariant(variantId, quantity);
    try { return await callback(); }
    finally { await restoreVariantQuantity(variantId, originalQuantity); document.dispatchEvent(new CustomEvent('cart:refresh')); }
  }

  async function calculate(root) {
    var input = root.querySelector('.mc-frete-cep');
    var zip = digits(input && input.value);
    renderRates(root, []);
    if (input) input.value = formatCep(zip);
    if (zip.length !== 8) { setStatus(root, 'Digite um CEP v\u00e1lido com 8 n\u00fameros.', 'error'); return; }
    setLoading(root, true);
    setStatus(root, 'Consultando op\u00e7\u00f5es de frete...', 'info');
    try {
      var rates = await withProductInCart(root, function () { return requestRates(zip); });
      if (!rates.length) { setStatus(root, 'N\u00e3o encontramos op\u00e7\u00f5es para este CEP. Confira o CEP ou fale com nosso atendimento.', 'error'); return; }
      setStatus(root, 'Op\u00e7\u00f5es encontradas:', 'success');
      renderRates(root, rates);
    } catch (error) { setStatus(root, error.message || 'N\u00e3o foi poss\u00edvel calcular o frete agora. Tente novamente em instantes.', 'error'); }
    finally { setLoading(root, false); }
  }

  function init(root) {
    if (!root || root.dataset.shippingReady === 'true') return;
    root.dataset.shippingReady = 'true';
    var input = root.querySelector('.mc-frete-cep');
    var submit = root.querySelector('.mc-frete-submit');
    if (input) {
      input.addEventListener('input', function () { input.value = formatCep(input.value); });
      input.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); calculate(root); } });
    }
    if (submit) submit.addEventListener('click', function (event) { event.preventDefault(); calculate(root); });
  }

  function initAll() { document.querySelectorAll(SELECTOR).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('cart:refresh', initAll);
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
})();
